<form [formGroup]="inputForm">
  <h1 mat-dialog-title>{{title}}</h1>
  <p [innerHTML]="message | safeHTML"></p>
  <mat-input-container>
    <input matInput [type]="aspassword === true ? 'password' : 'text'" name="userinput" formControlName="userinput" required />
    <mat-hint *ngIf="inputhint && (inputForm.get('userinput').valid || !inputForm.get('userinput').value)">{{inputhint}}</mat-hint>
    <mat-hint *ngIf="inputhint && !inputForm.get('userinput').valid && inputForm.get('userinput').value" [class.hinterror]="!inputForm.get('userinput').valid">Invalid email address</mat-hint>
  </mat-input-container>
  <!--<div mat-dialog-content>

  </div>-->
  <div mat-dialog-actions>
    <button mat-raised-button type="submit" color="primary" (click)="OKHandler()" [disabled]="!inputForm.valid">{{oktext}}</button>
    <button mat-raised-button type="button" color="warn" (click)="CancelHandler()">{{canceltext}}</button>
  </div>
</form>


// WEBPACK FOOTER //
// ./src/services/dialogs/inputbox/inputbox.dialogcomponent.html